"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _NicklistUser = _interopRequireDefault(require("./NicklistUser"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var log = _Logger.default.namespace('Nicklist');
var _default = exports.default = {
  components: {
    NicklistUser: _NicklistUser.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      userFilter: '',
      userFilterVisible: false,
      chatlatinosGenderByNick: Object.create(null),
      chatlatinosGenderHandler: null,
      chatlatinosWhoTimer: null
    };
  },
  computed: {
    sortedUsers: function sortedUsers() {
      var _this = this;
      var netPrefixes = this.network.ircClient.network.options.PREFIX;
      var prefixOrders = Object.create(null);
      netPrefixes.forEach(function (prefix, idx) {
        prefixOrders[prefix.mode] = idx;
      });
      var nickMap = Object.create(null);
      var users = [];
      var bufferUsers = this.buffer.users;
      var nickFilter = this.userFilter.toUpperCase();
      (0, _entries.default)(bufferUsers).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          uppercaseNick = _ref2[0],
          user = _ref2[1];
        nickMap[user.nick] = uppercaseNick;
        if (!nickFilter || uppercaseNick.indexOf(nickFilter) !== -1) {
          users.push(user);
        }
      });
      var bufferId = this.buffer.id;
      var groupAway = this.$state.setting('nicklistGroupAway');
      return (0, _sort.default)(users).call(users, function (a, b) {
        var bufferA = a.buffers[bufferId];
        var bufferB = b.buffers[bufferId];
        if (!bufferA) {
          var msg = 'Nicklist.sortedUsers() User A does not have the buffer in its list!';
          log.error(msg, a.nick, a.buffers);
          return -1;
        }
        if (!bufferB) {
          var _msg = 'Nicklist.sortedUsers() User B does not have the buffer in its list!';
          log.error(_msg, b.nick, b.buffers);
          return 1;
        }
        var modesA = bufferA.modes;
        var modesB = bufferB.modes;
        if (modesA.length === 0 && modesB.length === 0) {
          if (groupAway) {
            if (a.away && !b.away) {
              return 1;
            }
            if (!a.away && b.away) {
              return -1;
            }
          }
          return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
        }
        if (modesA.length > 0 && modesB.length === 0) {
          return -1;
        }
        if (modesA.length === 0 && modesB.length > 0) {
          return 1;
        }
        var aP = prefixOrders[_this.buffer.userMode(a)];
        var bP = prefixOrders[_this.buffer.userMode(b)];
        if (aP > bP) {
          return 1;
        } else if (aP < bP) {
          return -1;
        }
        if (groupAway) {
          if (a.away && !b.away) {
            return 1;
          }
          if (!a.away && b.away) {
            return -1;
          }
        }
        return Misc.strCompare(nickMap[a.nick], nickMap[b.nick]);
      });
    },
    groupedUsers: function groupedUsers() {
      var _this2 = this;
      var groups = [{
        id: 'chatlatinos-group-operators',
        type: 'header',
        label: 'Operadores',
        icon: '🛡️',
        count: 0,
        users: []
      }, {
        id: 'chatlatinos-group-voice',
        type: 'header',
        label: 'Voice',
        icon: '⭐',
        count: 0,
        users: []
      }, {
        id: 'chatlatinos-group-users',
        type: 'header',
        label: 'Usuarios',
        icon: '🙂',
        count: 0,
        users: []
      }];
      this.sortedUsers.forEach(function (user) {
        var role = _this2.userRole(user);
        if (role === 'operator') {
          groups[0].users.push(user);
        } else if (role === 'voice') {
          groups[1].users.push(user);
        } else {
          groups[2].users.push(user);
        }
      });
      var items = [];
      groups.forEach(function (group) {
        if (!group.users.length) {
          return;
        }
        items.push((0, _assign.default)({}, group, {
          count: group.users.length,
          users: undefined
        }));
        group.users.forEach(function (user) {
          items.push(user);
        });
      });
      return items;
    },
    allUsersCount: function allUsersCount() {
      return (0, _keys.default)(this.buffer.users).length;
    },
    shouldShowAvatars: function shouldShowAvatars() {
      return this.buffer.setting('nicklist_avatars');
    },
    nicklistItemSize: function nicklistItemSize() {
      return this.shouldShowAvatars ? 46 : 34;
    },
    useColouredNicks: function useColouredNicks() {
      return this.buffer.setting('coloured_nicklist');
    }
  },
  watch: {
    network: {
      immediate: true,
      handler: function handler() {
        this.unregisterGenderListener();
        this.registerGenderListener();
        this.requestWhoData();
      }
    },
    buffer: {
      immediate: true,
      handler: function handler() {
        this.requestWhoData();
      }
    }
  },
  mounted: function mounted() {
    this.registerGenderListener();
    this.requestWhoData();
  },
  beforeDestroy: function beforeDestroy() {
    this.unregisterGenderListener();
    if (this.chatlatinosWhoTimer) {
      clearTimeout(this.chatlatinosWhoTimer);
      this.chatlatinosWhoTimer = null;
    }
  },
  methods: {
    parseGenderFromRealName: function parseGenderFromRealName(realName) {
      var realNameText = String(realName || '');
      var realNameLower = realNameText.toLowerCase();
      var markerMatch = realNameLower.match(/\|g:([hmno])/);
      if (markerMatch) {
        return markerMatch[1];
      }
      if (realNameText.indexOf('🕺') !== -1) {
        return 'h';
      }
      if (realNameText.indexOf('🌸') !== -1) {
        return 'm';
      }
      if (realNameText.indexOf('🌈') !== -1) {
        return 'o';
      }
      if (realNameText.indexOf('🙂') !== -1) {
        return 'n';
      }
      return '';
    },
    registerGenderListener: function registerGenderListener() {
      var _this3 = this;
      if (!this.network || !this.network.ircClient || !this.network.ircClient.on) {
        return;
      }
      if (this.chatlatinosGenderHandler) {
        return;
      }
      this.chatlatinosGenderHandler = function (event) {
        if (!event || !event.users) {
          return;
        }
        event.users.forEach(function (user) {
          var _context;
          if (!user || !user.nick) {
            return;
          }
          var nickKey = (0, _trim.default)(_context = String(user.nick)).call(_context).toLowerCase();
          if (!nickKey) {
            return;
          }
          var realName = user.real_name || user.realname || user.gecos || '';
          var genderCode = _this3.parseGenderFromRealName(realName);
          if (genderCode) {
            _this3.$set(_this3.chatlatinosGenderByNick, nickKey, genderCode);
          }
        });
      };
      this.network.ircClient.on('irc.wholist', this.chatlatinosGenderHandler);
    },
    unregisterGenderListener: function unregisterGenderListener() {
      if (this.network && this.network.ircClient && this.network.ircClient.off && this.chatlatinosGenderHandler) {
        this.network.ircClient.off('irc.wholist', this.chatlatinosGenderHandler);
      }
      this.chatlatinosGenderHandler = null;
    },
    requestWhoData: function requestWhoData() {
      var _this4 = this;
      if (this.chatlatinosWhoTimer) {
        clearTimeout(this.chatlatinosWhoTimer);
        this.chatlatinosWhoTimer = null;
      }
      this.chatlatinosWhoTimer = setTimeout(function () {
        if (!_this4.network || !_this4.network.ircClient || !_this4.network.ircClient.raw || !_this4.buffer || !_this4.buffer.name) {
          return;
        }
        var bufferName = String(_this4.buffer.name || '');
        if (!bufferName || '#&'.indexOf(bufferName[0]) === -1) {
          return;
        }
        _this4.network.ircClient.raw("WHO ".concat(bufferName));
        setTimeout(function () {
          if (_this4.network && _this4.network.ircClient && _this4.network.ircClient.raw && _this4.buffer && _this4.buffer.name === bufferName) {
            _this4.network.ircClient.raw("WHO ".concat(bufferName));
          }
        }, 1500);
      }, 350);
    },
    genderForUser: function genderForUser(user) {
      var _context2;
      if (!user || !user.nick) {
        return 'n';
      }
      var nickKey = (0, _trim.default)(_context2 = String(user.nick)).call(_context2).toLowerCase();
      var storedGender = this.chatlatinosGenderByNick[nickKey];
      if (storedGender) {
        return storedGender;
      }
      var userRealName = user.real_name || user.realname || user.gecos || '';
      var userGender = this.parseGenderFromRealName(userRealName);
      if (userGender) {
        return userGender;
      }
      try {
        var localGender = localStorage.getItem('chatlatinos_gender') || '';
        var localNick = localStorage.getItem('chatlatinos_gender_nick') || '';
        if (nickKey && localNick && nickKey === localNick && ['h', 'm', 'o', 'n'].indexOf(localGender) !== -1) {
          return localGender;
        }
      } catch (error) {}
      return 'n';
    },
    userRole: function userRole(user) {
      var bufferUser = user.buffers[this.buffer.id];
      var modes = bufferUser && Array.isArray(bufferUser.modes) ? bufferUser.modes : [];
      var operatorModes = ['q', 'a', 'o', 'h'];
      if (modes.some(function (mode) {
        return operatorModes.indexOf(mode) !== -1;
      })) {
        return 'operator';
      }
      if (modes.indexOf('v') !== -1) {
        return 'voice';
      }
      var highestMode = this.buffer.userMode(user);
      if (operatorModes.indexOf(highestMode) !== -1) {
        return 'operator';
      }
      if (highestMode === 'v') {
        return 'voice';
      }
      return 'user';
    },
    openQuery: function openQuery(user) {
      var buffer = this.$state.addBuffer(this.buffer.networkid, user.nick);
      this.$state.setActiveBuffer(buffer.networkid, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.sidebarState.close();
      }
    },
    openUserbox: function openUserbox(user) {
      this.$state.$emit('userbox.show', user, {
        buffer: this.buffer
      });
    },
    toggleUserFilter: function toggleUserFilter() {
      var _this5 = this;
      this.userFilterVisible = !this.userFilterVisible;
      if (this.userFilterVisible) {
        this.$nextTick(function () {
          return _this5.$refs.user_filter.focus();
        });
      } else {
        this.userFilter = '';
      }
    },
    onFilterBlur: function onFilterBlur() {
      var _context3;
      if (!(0, _trim.default)(_context3 = this.userFilter).call(_context3)) {
        this.userFilter = '';
        this.userFilterVisible = false;
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Nicklist"]
window._kiwi_exports.components.Nicklist = exports.default ? exports.default : exports;
